export default __webpack_public_path__ + "static/media/tweet-offensive.d1b811ae.jpeg";